import { Borders } from 'components/designSystem/utilityClasses/Borders';
import { Fonts } from 'components/designSystem/utilityClasses/Fonts';
import { Margin } from 'components/designSystem/utilityClasses/Margin';
import { Padding } from 'components/designSystem/utilityClasses/Padding';
import { Shadows } from 'components/designSystem/utilityClasses/Shadows';
import { Page } from 'components/shared/Page';

export const UtilityClasses = () => (
    <div>
        <Page
            pageTitle="Utility Classes"
            pageDescription="Utility classes are single-purpose CSS classes. To apply the specific style from a class add the corresponding utility class directly to the HTML element."
            pageContent={
                <>
                    <div className="margin__bottom--x-large">
                        <img
                            style={{ backgroundColor: '#ffffff' }}
                            src="https://sseasacdn.blob.core.windows.net/strata-website/padding-margin-example.png"
                            alt="Padding and Margin Example"
                            loading="lazy"
                            width="300"
                        />
                    </div>
                    <Shadows />
                    <Margin />
                    <Borders />
                    <Padding />
                    <Fonts />
                </>
            }
        />
    </div>
);
